/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useState } from 'react';

function AntecedentesPrenatales(){
const [txtEdadGestacional, settxtEdadGestacional] = useState("");
const [cboTipoParto, setcboTipoParto] = useState("");
const [txtPesoNacimiento, settxtPesoNacimiento] = useState("");
const [txtTallaNacimiento, settxtTallaNacimiento] = useState("");
const [cboAPGAR1, setcboAPGAR1] = useState("");
const [cboAPGAR2, setcboAPGAR2] = useState("");
const [cboTerapiaIntensiva, setcboTerapiaIntensiva] = useState("");
const [txtMotivoTerapiaIntensiva, settxtMotivoTerapiaIntensiva] = useState("");
const [cboDadoAltaConMadre, setcboDadoAltaConMadre] = useState("");
const [cboPadecioIctericia, setcboPadecioIctericia] = useState("");
const [cboInfeccionEmbarazo, setcboInfeccionEmbarazo] = useState("");
const [txtInfeccionEmbarazo, settxtInfeccionEmbarazo] = useState("");
const [txtResEstudioTorch, settxtResEstudioTorch] = useState("");
const [fileEstudioTorch, setfileEstudioTorch] = useState(null);

    return <>
<Grid container spacing={2}>
    {/* Primera columna: Label y input de Edad Gestacional */}
    <Grid item xs={12} md={3} lg={3}>
        <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: 14 }}>
            Edad gestacional (semanas):
        </MDTypography>
    </Grid>
    <Grid item xs={12} md={3} lg={3}>
        <TextField
            type="number"
            inputProps={{ maxLength: 2 }}
            value={txtEdadGestacional}
            onChange={(e) => settxtEdadGestacional(e.target.value)}
            variant="outlined"
            fullWidth
        />
    </Grid>

    {/* Segunda columna: Label y ComboBox para Tipo de Parto */}
    <Grid item xs={12} md={3} lg={3}>
        <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: 14 }}>
            Producto de:
        </MDTypography>
    </Grid>
<Grid item xs={12} md={3} lg={3}>
    <Autocomplete
        options={[
            { label: "Parto natural", value: "1" },
            { label: "Cesárea", value: "2" }
        ]}
        getOptionLabel={(option) => option.label}
        value={cboTipoParto ? { label: cboTipoParto === "1" ? "Parto natural" : "Cesárea", value: cboTipoParto } : null}
        onChange={(event, newValue) => setcboTipoParto(newValue ? newValue.value : "")}
        renderInput={(params) => <TextField {...params} label="Seleccione tipo de parto" variant="outlined" fullWidth />}
    />
</Grid>

</Grid>
<br/>
<Grid container spacing={2}>
    {/* Primera columna: Label y input de Peso al nacer */}
    <Grid item xs={12} md={3} lg={3}>
        <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: 14 }}>
            Peso al nacer (kg):
        </MDTypography>
    </Grid>
    <Grid item xs={12} md={3} lg={3}>
        <TextField
            type="text"
            value={txtPesoNacimiento}
            onChange={(e) => settxtPesoNacimiento(e.target.value)}
            variant="outlined"
            fullWidth
        />
    </Grid>
    {/* Segunda columna: Label y input de Talla */}
    <Grid item xs={12} md={3} lg={3}>
        <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: 14 }}>
            Talla (cm):
        </MDTypography>
    </Grid>
    <Grid item xs={12} md={3} lg={3}>
        <TextField
            type="text"
            value={txtTallaNacimiento}
            onChange={(e) => settxtTallaNacimiento(e.target.value)}
            variant="outlined"
            fullWidth
        />
    </Grid>
</Grid>
<br/>
<Grid container spacing={2}>
    {/* Primera columna: Label de APGAR */}
    <Grid item xs={12} md={3} lg={3}>
        <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: 14 }}>
            APGAR:
        </MDTypography>
    </Grid>

    {/* Segunda columna: ComboBox para C1 */}
<Grid item xs={12} md={3} lg={3}>
    <Autocomplete
        options={[...Array(11).keys()].map((num) => ({
            label: num === 0 ? "N/A" : num.toString(),
            value: num
        }))}
        getOptionLabel={(option) => option.label}
        value={{ label: cboAPGAR1 === "" ? "- C1 -" : cboAPGAR1.toString(), value: cboAPGAR1 }}
        onChange={(event, newValue) => setcboAPGAR1(newValue ? newValue.value : "")}
        renderInput={(params) => <TextField {...params} label="C1" variant="outlined" fullWidth />}
    />
</Grid>


    {/* Tercera columna: ComboBox para C2 */}
<Grid item xs={12} md={3} lg={3}>
    <Autocomplete
        options={[...Array(11).keys()].map((num) => ({
            label: num === 0 ? "N/A" : num.toString(),
            value: num
        }))}
        getOptionLabel={(option) => option.label}
        value={{ label: cboAPGAR2 === "" ? "- C2 -" : cboAPGAR2.toString(), value: cboAPGAR2 }}
        onChange={(event, newValue) => setcboAPGAR2(newValue ? newValue.value : "")}
        renderInput={(params) => <TextField {...params} label="C2" variant="outlined" fullWidth />}
    />
</Grid>

</Grid>
<br/>
<Grid container spacing={2}>
    {/* Primera columna: Label y ComboBox para Terapia Intensiva */}
    <Grid item xs={12} md={3} lg={3}>
        <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: 14 }}>
            ¿Ha estado en terapia intensiva?
        </MDTypography>
    </Grid>
 <Grid item xs={12} md={3} lg={3}>
    <Autocomplete
        options={[
            { label: "Sí", value: "1" },
            { label: "No", value: "0" }
        ]}
        getOptionLabel={(option) => option.label}
        value={cboTerapiaIntensiva ? { label: cboTerapiaIntensiva === "1" ? "Sí" : "No", value: cboTerapiaIntensiva } : null}
        onChange={(event, newValue) => setcboTerapiaIntensiva(newValue ? newValue.value : "")}
        renderInput={(params) => <TextField {...params} label="Seleccione" variant="outlined" fullWidth />}
    />
</Grid>
    {/* Segunda columna: Label y input para Motivo/Duración de la estancia */}
    <Grid item xs={12} md={3} lg={3}>
        <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: 14 }}>
            Motivo/Duración de la estancia (días):
        </MDTypography>
    </Grid>
    <Grid item xs={12} md={3} lg={3}>
        <TextField
            type="text"
            value={txtMotivoTerapiaIntensiva}
            onChange={(e) => settxtMotivoTerapiaIntensiva(e.target.value)}
            variant="outlined"
            fullWidth
        />
    </Grid>
</Grid>
<br/>
<Grid container spacing={2}>
    {/* Primera columna: Label y ComboBox para Dado de alta con la madre */}
    <Grid item xs={12} md={3} lg={3}>
        <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: 14 }}>
            ¿Dado de alta con la madre?
        </MDTypography>
    </Grid>
 <Grid item xs={12} md={3} lg={3}>
    <Autocomplete
        options={[
            { label: "Sí", value: "1" },
            { label: "No", value: "0" }
        ]}
        getOptionLabel={(option) => option.label}
        value={cboDadoAltaConMadre ? { label: cboDadoAltaConMadre === "1" ? "Sí" : "No", value: cboDadoAltaConMadre } : null}
        onChange={(event, newValue) => setcboDadoAltaConMadre(newValue ? newValue.value : "")}
        renderInput={(params) => <TextField {...params} label="Seleccione" variant="outlined" fullWidth />}
    />
</Grid>
    {/* Segunda columna: Label y ComboBox para Padeció ictericia */}
    <Grid item xs={12} md={3} lg={3}>
        <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: 14 }}>
            ¿Padeció ictericia?
        </MDTypography>
    </Grid>
<Grid item xs={12} md={3} lg={3}>
    <Autocomplete
        options={[
            { label: "Sí", value: "1" },
            { label: "No", value: "0" }
        ]}
        getOptionLabel={(option) => option.label}
        value={cboPadecioIctericia ? { label: cboPadecioIctericia === "1" ? "Sí" : "No", value: cboPadecioIctericia } : null}
        onChange={(event, newValue) => setcboPadecioIctericia(newValue ? newValue.value : "")}
        renderInput={(params) => <TextField {...params} label="Seleccione" variant="outlined" fullWidth />}
    />
</Grid>
</Grid>
<br/>
<Grid container spacing={2}>
    {/* Primera columna: Label y ComboBox para infección en el embarazo */}
    <Grid item xs={12} md={3} lg={3}>
        <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: 14 }}>
            ¿Alguna infección importante durante el embarazo?
        </MDTypography>
    </Grid>
 <Grid item xs={12} md={3} lg={3}>
    <Autocomplete
        options={[
            { label: "Sí", value: "1" },
            { label: "No", value: "0" }
        ]}
        getOptionLabel={(option) => option.label}
        value={cboInfeccionEmbarazo ? { label: cboInfeccionEmbarazo === "1" ? "Sí" : "No", value: cboInfeccionEmbarazo } : null}
        onChange={(event, newValue) => setcboInfeccionEmbarazo(newValue ? newValue.value : "")}
        renderInput={(params) => <TextField {...params} label="Seleccione" variant="outlined" fullWidth />}
    />
</Grid>
    {/* Segunda columna: Label y input para especificar infección */}
    <Grid item xs={12} md={3} lg={3}>
        <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: 14 }}>
            Especifique:
        </MDTypography>
    </Grid>
    <Grid item xs={12} md={3} lg={3}>
        <TextField
            type="text"
            value={txtInfeccionEmbarazo}
            onChange={(e) => settxtInfeccionEmbarazo(e.target.value)}
            variant="outlined"
            fullWidth
        />
    </Grid>
</Grid>
<br/>
<Grid container spacing={2}>
    {/* Primera columna vacía (sin label) */}
    <Grid item xs={12} md={3} lg={3}></Grid>

    {/* Segunda columna: Texto "Subir Estudio" y input tipo file */}
    <Grid item xs={12} md={6} lg={6}>
        <MDBox display="flex" alignItems="center">
            <MDTypography variant="h6" color="white" style={{ opacity: 0.7 }}>
                Subir Estudio:
            </MDTypography>
            <input
                type="file"
                onChange={(e) => setfileEstudioTorch(e.target.files[0])}
                style={{ marginLeft: 15 }}
            />
        </MDBox>
    </Grid>
</Grid>
    </>
}

export default AntecedentesPrenatales;